import { Menu, PlainButton } from "@jugl-web/ui-components";
import { cx, useAppVariant, useTranslations } from "@jugl-web/utils";
import React, { useCallback, useState } from "react";
import { useClientSupportPageContext } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/ClientSupportPageProvider/useClientSupportPageContext";
import {
  ManageContactAlert,
  ManageContactAlertVariant,
} from "../../../ManageContactAlert";
import { useManageContact } from "../../../../hooks/useManageContact";
import { ReactComponent as BlockIcon } from "./assets/block.svg";
import { ReactComponent as MoreIcon } from "./assets/more.svg";
import { ReactComponent as UnblockIcon } from "./assets/unblock.svg";
import { collapsedIconButtonClassName } from "../../../../consts";

export const CustomerActionsMenu: React.FC = () => {
  const [isManageContactAlertOpen, setIsManageContactAlertOpen] =
    useState(false);
  const [manageContactAlertVariant, setManageContactAlertVariant] = useState<
    ManageContactAlertVariant | undefined
  >();
  const { t } = useTranslations();
  const { isCx } = useAppVariant();
  const { selectedConversation, isContactBlocked, isChatExpired } =
    useClientSupportPageContext();
  const { contactName, isManageContactLoading, handleManageContact } =
    useManageContact();

  const handleManageContactMenuSelect = useCallback(() => {
    setManageContactAlertVariant(isContactBlocked ? "unblock" : "block");
    setIsManageContactAlertOpen(true);
  }, [isContactBlocked]);

  if (!selectedConversation || (isChatExpired && !isContactBlocked)) {
    return null;
  }

  return (
    <>
      <Menu
        placement="bottom-end"
        autoClose
        onSelect={handleManageContactMenuSelect}
        sections={[
          [
            {
              id: "block-user",
              icon: <BlockIcon />,
              label: isCx
                ? t({
                    id: "client-support-page.block-customer",
                    defaultMessage: "Block Customer",
                  })
                : t({
                    id: "client-support-page.block-user",
                    defaultMessage: "Block User",
                  }),
              isHidden: isContactBlocked,
            },
            {
              id: "unblock-user",
              icon: <UnblockIcon />,
              label: isCx
                ? t({
                    id: "client-support-page.unblock-customer",
                    defaultMessage: "Unblock Customer",
                  })
                : t({
                    id: "client-support-page.unblock-user",
                    defaultMessage: "Unblock User",
                  }),
              isHidden: !isContactBlocked,
            },
          ],
        ]}
        renderTrigger={({ Trigger, triggerRef }) => (
          <Trigger
            ref={triggerRef}
            as={PlainButton}
            className={cx(collapsedIconButtonClassName, "h-8 w-8")}
            disabled={isManageContactLoading}
          >
            <MoreIcon />
          </Trigger>
        )}
      />
      <ManageContactAlert
        variant={manageContactAlertVariant}
        contactName={contactName}
        isOpen={isManageContactAlertOpen}
        onConfirm={handleManageContact}
        onRequestClose={() => {
          setIsManageContactAlertOpen(false);
          setManageContactAlertVariant(undefined);
        }}
      />
    </>
  );
};
